module.exports = __webpack_public_path__ + "static/img/trade-icon3.8f210e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trade-icon3.png
// module id = GfGS
// module chunks = 0